Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DMipFilter = module.exports.default = {
	MIPLINEAR: "miplinear",
	MIPNEAREST: "mipnearest",
	MIPNONE: "mipnone"
};